import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const names = ['Lucía', 'Martín', 'Diego', 'Sofía', 'Federico', 'Camila', 'Juan', 'Valentina', 'Tomás', 'Agustina'];
const initials = ['M.', 'P.', 'G.', 'R.', 'V.', 'A.', 'C.', 'L.', 'S.', 'B.'];
const cities = ['Mendoza', 'Buenos Aires', 'Córdoba', 'Rosario', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function RecentPurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    initial: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomInitial = initials[Math.floor(Math.random() * initials.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins
      setPurchaseData({
        name: randomName,
        initial: randomInitial,
        city: randomCity,
        time: `${randomTime} min`
      });
      setIsVisible(true);
      // Hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    // Show every 30 seconds
    const interval = setInterval(() => {
      showPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-263">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-[300px] md:max-w-sm bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" data-id="element-264">
          <div className="bg-tennis-green/10 text-tennis-green p-2 rounded-full shrink-0 mt-0.5" data-id="element-265">
            <ShoppingCartIcon size={18} data-id="element-266" />
          </div>

          <div className="pr-4" data-id="element-267">
            <p className="text-sm text-charcoal font-medium leading-tight" data-id="element-268">
              <span className="font-bold" data-id="element-269">
                {purchaseData.name} {purchaseData.initial}
              </span>{' '}
              de {purchaseData.city} acaba de comprar TENIS 360
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-270">
              hace {purchaseData.time}
            </p>
          </div>

          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-271">
            ×
          </button>
        </motion.div>}
    </AnimatePresence>;
}